export default __webpack_public_path__ + "static/media/start-bg.6e3f177f.webp";